import { Type } from 'class-transformer';

import { Media } from '@eiq/files/models';

import { MonitorTerms } from './monitor-terms.model';

export class SurveySettings {
  @Type(() => Media)
  logo: Media;

  @Type(() => Media)
  iconLogo: Media;

  defaultLogoInd: boolean;
  defaultIconLogoInd: boolean;
  showLogoInd: boolean;
  useTitleInd: boolean;
  useFeedbackInd: boolean;
  isBackButtonDisabled: boolean;
  monitorTerms: MonitorTerms;
}
